
























































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import Modal from "../shared/modal/Modal.vue";
import ShipmentGrid from "./ShipmentGrid.vue";
import ImportGrid from "./ImportGrid.vue";
import ImportGridModal from "./ImportGridModal.vue";
import store from "@/vuex/store";
import { ShipmentService } from "@/services/ShipmentService";
import { getTenantId, tokenValid } from "@/services/AuthService";
import ArticleNewsWidget from "@/components/shared/ArticleNewsWidget.vue";
import { BannerTypes, QuickAccessLink } from "@/model/component.model";
import { RawLocation } from "vue-router";
import { Watch } from "vue-property-decorator";
import { getCountryOrCompanyNameLabelBasedOnTenant } from "@/services/Helpers";

@Component({
  components: {
    MbeModal: Modal,
    MbeShipmentGrid: ShipmentGrid,
    MbeImportGrid: ImportGrid,
    MbeImportGridModal: ImportGridModal,
    ArticleNewsWidget
  }
})
export default class ShipmentsMenuNew extends Vue {
  modalVisible = "";
  showImportGrid = false;
  showPickupSections = false;
  modalType = "";
  windowWidth = window.innerWidth;
  isTokenValid = tokenValid(null);
  currentYear = "";
  currentBusinessName = "";

  async created() {
    store.dispatch("versionCheck");
    this.isPickupCourierEnabled();
    store.cache.dispatch("cachemod/getCurrentDate").then(res => {
      const currentDate = res;
      const currentTimeZone = String(new Date())
        .split(":")[2]
        .split(" ")[1];
      this.currentYear = new Date(
        JSON.parse(
          JSON.stringify(
            new Date(currentDate + " " + currentTimeZone).toUTCString()
          )
        )
      )
        .getFullYear()
        .toString();
    });
  }

  isPickupCourierEnabled() {
    ShipmentService.getPickupCouriers().then(res => {
      this.showPickupSections = res.length > 0;
      if (res.length > 0) {
        const ids = [];
        res.forEach(item => ids.push(item.mbeServiceId));
        this.$store.state.customer.mbeServiceIds = ids;
      }
    });
  }

  get isAmazonEnabled() {
    return this.$store.getters["customer/config"].amazonEnabled;
  }

  get isShipmentsImportXlsEnable() {
    return this.$store.getters["customer/config"].enableShipmentsImportXls;
  }

  updateWindowSize() {
    this.windowWidth = window.innerWidth;
    this.updateCarouselHeight();
  }

  updateCarouselHeight() {
    this.$nextTick(() => {
      const container = this.$refs.carouselContainer;
      if (!container) return;

      const image = (container as any).querySelector(".slider-img");
      if (!image) return;

      // Get the aspect ratio of the image
      const aspectRatio = image.naturalWidth / image.naturalHeight;

      // Set the carousel height dynamically based on width
      if (this.$refs.carousel) {
        const carouselWidth = (this.$refs.carousel as any).$el.clientWidth;
        const newHeight = carouselWidth / aspectRatio; // Maintain aspect ratio
        (this.$refs.carousel as any).$el.style.height = `${newHeight}px`;
      }
    });
  }

  @Watch("isDesktop")
  onIsDesktopChange(status: boolean) {
    if (!status) return;
  }

  mounted() {
    window.addEventListener("resize", this.updateWindowSize);
  }

  destroy() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  get isDesktop() {
    return this.windowWidth > 1024;
  }

  get isTablet() {
    return this.windowWidth <= 1024 && this.windowWidth >= 768;
  }

  get isMobile() {
    return this.windowWidth < 768;
  }

  get bannerListByType() {
    return (itemType: BannerTypes) => {
      const language = this.$store.getters.language;
      const banners = this.$store.getters.banners;
      const bannersLangObj = banners[language];
      if (!bannersLangObj || !Object.keys(bannersLangObj).length) return [];
      let bannerType = "";
      if (itemType === "DESKTOP") bannerType = "desktop";
      if (itemType === "TABLET") bannerType = "tablet";
      if (itemType === "MOBILE") bannerType = "mobile";
      if (!bannerType) return [];
      if (!bannersLangObj[bannerType] || !bannersLangObj[bannerType].length)
        return [];
      return bannersLangObj[bannerType];
    };
  }

  get desktopBannerList() {
    return this.bannerListByType("DESKTOP").filter((el: any) => {
      return this.checkBannerVisibility(el);
    });
  }

  get tabletBannerList() {
    return this.bannerListByType("TABLET").filter((el: any) => {
      return this.checkBannerVisibility(el);
    });
  }

  get mobileBannerList() {
    return this.bannerListByType("MOBILE").filter((el: any) => {
      return this.checkBannerVisibility(el);
    });
  }

  get isEship() {
    return this.$store.getters.envs.isEShip;
  }

  get isLocal() {
    return this.$store.getters.isLocal;
  }

  get canSelectShipmentType() {
    return this.$store.getters["customer/config"].canSelectSShipmentType;
  }

  get hasFeatureBound() {
    return this.$store.getters.features.inbound;
  }

  get canShowWine2Shipments() {
    return this.$store.getters["customer/config"].showWine2Shipment;
  }

  get canShowPrices() {
    return this.$store.getters["customer/config"].showPrices;
  }

  get canSeeClaimButton() {
    return (
      this.$store.getters["customer/claimConfig"].canSeeMolIncidents ||
      this.$store.getters["customer/claimConfig"].canSeeMolClaims ||
      this.$store.getters["customer/claimConfig"].canSeeStoreClaims
    );
  }

  get storePaperlessEnabled() {
    return this.$store.getters.features.storePaperlessEnabled;
  }

  get pickupEnabled() {
    return this.$store.getters["customer/config"].pickupEnabled;
  }

  get bannerUrl() {
    return banner => {
      const lang = this.$store.getters.language;
      return `${
        window.location.origin
      }/responsive-banners/${lang}/${banner?.img || ""}`;
    };
  }

  get quickAccessLeftList() {
    if (this.quickAccessList.length <= 6) return this.quickAccessList;
    return this.quickAccessList.filter(
      (item: QuickAccessLink, index: number) => index < 6
    );
  }

  get quickAccessRightList() {
    return this.quickAccessList.filter(
      (item: QuickAccessLink) =>
        !this.quickAccessLeftList.some(
          (el: QuickAccessLink) => el.name === item.name
        )
    );
  }

  showImportGridModal(name: string, modalType: string) {
    if ((window as any).dataLayer) {
      const layerData = {
        event: "click_quick_access_menu",
        event_data: {
          click_text: this.$i18n.t(name, { lng: "en" })
        }
      };
      (window as any).dataLayer.push(layerData);
    }
    this.showImportGrid = true;
    this.modalType = modalType;
  }

  async redirectSlide(url: string) {
    if (!url) return;
    if ((window as any).dataLayer) {
      const layerData = {
        event: "click_banner",
        event_data: {
          click_text: "FIND OUT MORE",
          link_url: url
        }
      };
      (window as any).dataLayer.push(layerData);
    }
    await window.open(url, "_blank");
  }

  async navigateRoute(name: string, route: string, query?: object) {
    if (!route) return;
    if ((window as any).dataLayer) {
      const layerData = {
        event: "click_quick_access_menu",
        event_data: {
          click_text: this.$i18n.t(name, { lng: "en" })
        }
      };
      (window as any).dataLayer.push(layerData);
    }
    await this.$router.push({
      name: route,
      query: query || {}
    } as RawLocation);
  }

  get quickAccessList(): QuickAccessLink[] {
    const list: QuickAccessLink[] = [
      {
        name: "new_shipment_button",
        clickAction: () => {
          this.navigateRoute("new_shipment_button", "NewShipment");
        },
        svgImage: "ship-out.svg"
      }
    ];

    // if(this.isEship || this.isLocal){
    //   list.push(
    //     {
    //       route: "NewShipment",
    //       name: "new_shipment_third_part",
    //       class: "mbelabels",
    //       query: { type: "third_part" },
    //     }
    //   );
    // }
    if (this.canSelectShipmentType && this.hasFeatureBound) {
      list.push({
        name: "new_shipment_inbound",
        svgImage: "ship-in.svg",
        clickAction: () => {
          this.navigateRoute("new_shipment_inbound", "NewShipment", {
            type: "inbound"
          });
        }
      });
    }

    if (
      (this.$store.getters["customer/config"].enableWineShipmentCreation ||
        this.$store.getters["customer/config"].enableSpiritsShipmentCreation) &&
      this.$store.getters.features.wineVisibilty
    ) {
      list.push({
        name: "new_wine_shipment",
        svgImage: "ship-out.svg",
        clickAction: () => {
          this.navigateRoute("new_wine_shipment", "NewShipment", {
            type: "wine"
          });
        }
      });
    }

    list.push({
      name: "shipments_management",
      svgImage: "mbe.svg",
      clickAction: () => {
        this.navigateRoute("shipments_management", "ShipmentsManagement");
      }
    });

    if (
      this.canShowWine2Shipments &&
      this.$store.getters.features.wineVisibilty
    ) {
      list.push({
        name: "wine_shipments_management",
        svgImage: "manage.svg",
        clickAction: () => {
          this.navigateRoute(
            "wine_shipments_management",
            "WineShipmentsManagement"
          );
        }
      });
    }

    if (this.canSeeClaimButton) {
      list.push({
        name: "claim_management",
        svgImage: "manage.svg",
        clickAction: () => {
          this.navigateRoute("claim-management", "ClaimManagement");
        }
      });
    }

    list.push({
      name: "mbe_centre_pickups",
      svgImage: "receive.svg",
      clickAction: () => {
        this.navigateRoute("mbe_centre_pickups", "PickupsList");
      }
    });
    list.push({
      name: "historic_closures",
      svgImage: "history.svg",
      clickAction: () => {
        this.navigateRoute("historic_closures", "ClosuresList");
      }
    });

    if (this.canShowPrices) {
      list.push({
        name: "shipment_cost_calculate",
        svgImage: "price.svg",
        clickAction: () => {
          this.navigateRoute(
            "shipment_cost_calculate",
            "ShipmentCostCalculate"
          );
        }
      });
    }

    if (this.isAmazonEnabled) {
      list.push({
        clickAction: () => {
          this.showImportGridModal("importAmazon", "amazon");
        },
        name: "importAmazon",
        svgImage: "amazon.svg"
      });
    }

    if (this.isShipmentsImportXlsEnable) {
      list.push({
        clickAction: () => {
          this.showImportGridModal("importExcel", "excel");
        },
        name: "importExcel",
        svgImage: "excel.svg"
      });
    }

    if (
      this.storePaperlessEnabled &&
      !this.$store.getters["customer/config"].disablePaperlessFeature
    ) {
      list.push({
        name: "paperless_management",
        svgImage: "cloud.svg",
        clickAction: () => {
          this.navigateRoute("paperless_management", "PaperlessManagement");
        }
      });
    }

    if (this.pickupEnabled && this.showPickupSections) {
      list.push({
        name: "courier_pickup_management",
        svgImage: "currier.svg",
        clickAction: () => {
          this.navigateRoute(
            "courier_pickup_management",
            "CourierPickupsManagement"
          );
        }
      });
    }

    return list;
  }

  closeShipmentsModalBtn = {
    disabled: true
  };

  shipmentTypes: any = [
    {
      label: "Mbe Wine",
      value: "wine"
    },
    {
      label: "MBE Wine Tracking",
      value: "winetracking"
    },
    {
      label: "Safevalue",
      value: "safevalue"
    }
  ];

  importTypes: any = [
    {
      label: "e-Commerce",
      value: "ecommerce"
    },
    {
      label: "Excel",
      value: "excel"
    },
    {
      label: "FTP",
      value: "ftp"
    }
  ];

  selectedShipment = "";
  selectedImport = "";

  handleNewShipment() {
    this.$router.push({ name: "NewShipment" });
  }

  selectThisType() {
    if (!this.selectedShipment && !this.selectedImport) return;
    if (this.modalVisible === "shipment") {
      this.$router.push({
        name: "NewShipment",
        params: { type: this.selectedShipment }
      });
    } else if (this.modalVisible === "import") {
      this.$router.push({ name: "NewImport" });
    }
  }

  toggleModal(modal: string) {
    this.modalVisible = modal;
  }

  closeModal() {
    this.modalVisible = "";
  }

  onShipmentSelected($event: string) {
    this.selectedShipment = $event;
    this.closeShipmentsModalBtn.disabled = false;
  }

  onImportSelected($event: string) {
    this.selectedImport = $event;
    this.closeShipmentsModalBtn.disabled = false;
  }

  checkBannerVisibility(banner): boolean {
    if (banner.excludedTenants?.includes(getTenantId())) return false;
    if (!banner.expiration) return true;
    const now = new Date();
    const limit = new Date(banner.expiration);
    return now <= limit;
  }

  getMBELink(banner) {
    const tenantLang = this.$store.getters["customer/storeInfo"].store.storeCode
      .substring(0, 2)
      .toLowerCase();

    if (tenantLang === "pl") {
      if (banner === "2.MBESafeValue_Visual-Business_Banner_PL.png") {
        return "https://mbe.pl/pl/safevalue";
      }

      if (banner === "ecomm_PL.png") {
        return "https://www.mbe.pl/pl/";
      }

      if (banner === "4_MBE Online slider MARS24 1000x315 PL.jpg") {
        return "https://www.pl.prestashop.com";
      }
    }
    if (tenantLang === "it") {
      if (banner === "1_MBESafeValue_Visual-Business_Banner_ITA.jpg") {
        return "https://www.mbe.it/it/safevalue";
      }

      if (banner === "ecomm_IT.jpg") {
        return "https://www.mbe.it/it";
      }

      if (banner === "3_banner_MOL_MBEPrivilege_Q2_def.jpg") {
        return "https://www.mbeprivilege.it";
      }

      if (banner === "4_MBExPS_Banner-MOL_ITA.jpg") {
        return "https://www.mbe.it/it/prestashop";
      }
    }
    if (tenantLang === "fr") {
      if (banner === "2.MBESafeValue_Visual-Business_Banner.png") {
        return "https://www.mbefrance.fr/fr/safevalue";
      }

      if (banner === "ecomm_FR.jpg") {
        return "https://www.mbefrance.fr";
      }

      if (banner === "4_MBExPS_Banner-MOL.png") {
        return "https://www.mbefrance.fr/fr/prestashop";
      }
    }
    if (tenantLang === "es") {
      if (banner === "2.MBESafeValue_Visual-Business_Banner_ES.jpg") {
        return "https://www.mbe.es/es/envios-embalaje/mbe-safevalue-cobertura-entrega-reembolso";
      }

      if (banner === "ecomm_Es.jpg") {
        return "https://www.mbe.es";
      }

      if (banner === "3_banner_MOL_MBEPrivilege_Q2_ES.jpg") {
        return "https://www.mbeprivilege.es";
      }

      if (banner === "4_MBExPS_Banner-MOL.jpg") {
        return "https://www.mbe.es/es/prestashop";
      }
    }
    if (tenantLang === "de") {
      if (banner === "1_MBESafeValue_Visual-Business_Banner_GER.jpg") {
        return "https://www.mbe.de/de/mbe-safevalue";
      }

      if (banner === "ecomm_GER.jpg") {
        return "https://www.mbe.de/de";
      }

      if (banner === "Copia di 3_MBE Privilege_Banner mbe online_GER.jpg") {
        return "https://www.mbeprivilege.de";
      }
    }
    if (tenantLang === "en") {
      if (banner === "1_MBESafeValue_Visual-Business_Banner.jpg") {
        return "https://www.mbe.co.uk/business/coverprotect";
      }

      if (banner === "ecomm_EN.jpg") {
        return "https://www.mbe.uk";
      }

      if (banner === "4_MBE Online slider MARS24 1000x315 EN.jpg") {
        return "https://www.prestashop.com";
      }
    }
    if (tenantLang === "pt") {
      if (banner === "ecomm_PT.jpg") {
        return "https://www.mbe.pt";
      }

      if (banner === "2_Corporate_Gift Online Banner_1000x315_PT.jpg") {
        return "https://www.mbe.pt";
      }
    }
    return "https://www.mbe.{0}".replace("{0}", tenantLang);
  }

  get footerMessage() {
    return `${this.currentYear} MBE Worldwide`;
  }
}
